module.exports = __webpack_public_path__ + "images/FUSA_icons/040-buy.a76a3ae106d701f9557b49f40160bf7e.svg";